import cn from 'classnames';
import React, {useEffect, useRef, useState} from 'react';
import {RemoveScroll} from 'react-remove-scroll';

import {twx} from '@/utils/tailwindUtils';

import AppPopup from './AppPopup';
import styles from './Popup.module.scss';
import useOneModalOnPageAtATime from './useOneModalOnPageAtATime';

const PopupStickedWithSwipeClose = ({
    className,
    swipeAreaClassName,
    children,
    onClose,
    isCloseVisible,
    isSwipeDashVisible = true,
    isOpen = true,
    ...rest
}) => {
    const isVisible = useOneModalOnPageAtATime({isOpen});
    const [isPopupClosing, setIsPopupClosing] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, []);

    if (!isVisible) return null;

    let touchYStart = 0;
    let touchYEnd = 0;

    const onTouchStart = (e) => {
        touchYStart = e.changedTouches[0].pageY;
    };

    const onTouchMove = (e) => {
        touchYEnd = e.changedTouches[0].pageY;

        const delta = touchYEnd - touchYStart;
        const SWIPE_DELTA_TO_START_CLOSING = 30;

        if (delta >= SWIPE_DELTA_TO_START_CLOSING && onClose) {
            onPopupClose();
        }
    };

    const onPopupClose = () => {
        if (timeoutRef.current) return;

        setIsPopupClosing(true);
        timeoutRef.current = setTimeout(() => {
            onClose();
            setIsPopupClosing(false);
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }, 700);
    };

    return (
        <RemoveScroll enabled={isOpen}>
            <AppPopup
                className={twx(
                    styles.PopupContainer,
                    'rounded-t-3xl px-4 pt-0 pb-safe-offset-4',
                    {[styles.PopupOnClose]: isPopupClosing},
                    className
                )}
                overlayClassName={cn(styles.Overlay, {[styles.OverlayOnPopupClose]: isPopupClosing})}
                onClose={onClose}
                isOpen={isOpen}
                {...rest}
                isCloseVisible={isCloseVisible}
            >
                <div className={twx('py-6', swipeAreaClassName)} onTouchMove={onTouchMove} onTouchStart={onTouchStart}>
                    {isSwipeDashVisible && <div className='mx-auto h-1 w-8 rounded-2xl bg-primary-tins-slate' />}
                </div>
                {children}
            </AppPopup>
        </RemoveScroll>
    );
};

export default PopupStickedWithSwipeClose;
